import { groupBy } from 'lodash';
import { orderbookMap2Array } from '@/utils/grouping';
import { Board, OrderbookSide, OrderbookMap } from '@/types/orderbook';

export class Orderbook {
  private bidsAsks: OrderbookMap = {
    bids: new Map(),
    asks: new Map(),
  };
  private isSnapshot = false;
  public getOrderbook() {
    if (this.isSnapshot) {
      return orderbookMap2Array(this.bidsAsks);
    }
  }
  public clear() {
    this.isSnapshot = false;
    this.bidsAsks.bids.clear();
    this.bidsAsks.asks.clear();
  }
  public _setData(data: Array<Array<number | number[]>>) {
    if (!this.isSnapshot) {
      this._partial((data as number[][][])[1]);
    } else {
      const cnt = data[1][1];
      const board: Board = { price: (data as number[][])[1][0], size: (data as number[][])[1][2] };
      if (!cnt) {
        this._delete(board);
      } else {
        this._update(board);
      }
    }
  }
  private _delete(data: Board) {
    const side = data.size >= 0 ? 'bids' : 'asks';
    this.bidsAsks[side].delete(data.price + '');
  }
  private _update(data: Board) {
    const side = data.size >= 0 ? 'bids' : 'asks';
    data.size = Math.abs(data.size);
    this.bidsAsks[side].set(data.price + '', data);
  }
  private _partial(snapshotData: number[][]) {
    this.isSnapshot = true;
    const bidsAsks = groupBy(snapshotData, (pp) => {
      return pp[2] >= 0 ? 'bids' : 'asks';
    });
    Object.keys(bidsAsks).forEach((side) => {
      this.bidsAsks[side as OrderbookSide] = new Map(
        bidsAsks[side as OrderbookSide].map((pp) => {
          const key = pp[0] + '';
          const board = {
            price: pp[0],
            size: Math.abs(pp[2]),
          };
          return [key, board] as [string, Board];
        }),
      );
    });
  }
}
